import React, { lazy, Suspense } from "react";

import { useWebsiteConfig } from "../hooks/useData";
import { StructuredData, SEO } from "../components/SEO";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";

// Lazy load below-the-fold components
const Products = lazy(() => import("../components/Products"));
const Statistics = lazy(() => import("../components/Statistics"));
const WhyChooseUs = lazy(() => import("../components/WhyChooseUs"));
const Pricing = lazy(() => import("../components/Pricing"));
const Testimonials = lazy(() => import("../components/Testimonials"));
const Download = lazy(() => import("../components/Download"));
const Footer = lazy(() => import("../components/Footer"));

const Home = () => {
  const website = useWebsiteConfig();

  return (
    <>
      <StructuredData />
      <SEO keywords="virtual software house pakistan, software house pakistan, custom software development, web development company, mobile app development, mandi software, petrol pump management system" />
      <div className="w-full overflow-x-hidden">
        <Navigation />

        <main id="main-content">
          {/* Step 1: Hook the User */}
          <Hero />

          {/* Defer loading for anything below the fold */}
          <Suspense
            fallback={
              <div className="min-h-[200px] flex items-center justify-center">
                Loading section...
              </div>
            }
          >
            {/* Step 2: Show the Value (Social Proof) */}
            <Statistics />

            {/* Step 3: The Offer (Main Products) */}
            <Products />

            {/* Step 4: Build Trust */}
            <WhyChooseUs />
            <Testimonials />

            {/* Step 5: Close the Deal */}
            <Pricing />
            <Download />
          </Suspense>
        </main>

        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default Home;
